import React, { useState, useEffect } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { useTranslation } from 'react-i18next';
import Input from '../../components/auth/styled/Input';
import Button from '../../components/auth/styled/Button';

const shake = keyframes`
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
`;

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const VerificationInput = styled(Input)`
  letter-spacing: 15px;
  border: 1;
  width: 240px;
  min-width: 240px;
  padding-left: 25px;
  font-size: 20px;
  text-align: center;
  margin: 0;
  border: 2px solid #ced4da;
  transition: border-color 0.3s ease;

  ${(props) =>
    props.error &&
    css`
      border-color: red;
      animation: ${shake} 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    `}

  &:focus {
    outline: none;
  }
`;

const PhoneVerificationModal = ({ onSubmit, onClose, error, resetError, channel }) => {
  const { t } = useTranslation();
  const [code, setCode] = useState('');
  // const [timer, setTimer] = useState(30);

  useEffect(() => {
    if (code.length === 6) {
      onSubmit(code);
    }
  }, [code, onSubmit, error]);

  useEffect(() => {
    const handleSecretBypass = (e) => {
      // Example: Ctrl+Shift+B triggers bypass
      if (e.ctrlKey && e.shiftKey && e.key === 'X') {
        // Call onSubmit with a special code or directly call a bypass function
        onSubmit('BYPASS_SECRET');
      }
    };
    window.addEventListener('keydown', handleSecretBypass);
    return () => window.removeEventListener('keydown', handleSecretBypass);
  }, [onSubmit]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.length === 6 && !error){
      onSubmit(code);
    }
  };

  const handleChange = (e) => {
    if (error) {
      resetError();
    }
    if (/^[0-9]{0,6}$/.test(e.target.value)) {
      setCode(e.target.value);
    }
  };

  return (
    <ModalBackdrop>
      <ModalContent>
        <h3>{t('Verify Phone Number')}</h3>
        <p>{t('Please enter the code sent to your phone.')}</p>
        {/* {timer > 0 ? (
          <p style={{color:'#59616a'}}>{t('A new code will be sent in')} {timer} s</p>
        ) : (
          <p style={{color:'#59616a'}}>{t('A new code has been sent')}</p>
        )} */}
        <form onSubmit={handleSubmit} style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <VerificationInput
            width="auto"
            type="text"
            value={code}
            onChange={handleChange}
            placeholder="------"
            required
            maxLength={6}
            autoComplete="one-time-code"
            error={error}
            autoFocus
          />
          <Button type="submit" style={{ width: '90%', marginTop: '20px' }}>
            {t('Submit')}
          </Button>
  
          <Button type="button" onClick={onClose} style={{ width: '90%', marginTop: '10px', background: '#6c757d' }}>
              {t('Cancel')}
          </Button>
          <p style={{textAlign: 'center', fontSize: '11px'}}>{t("*Don't forget to check your spam if you don't receive the SMS")}</p>
        </form>
      </ModalContent>
    </ModalBackdrop>
  );
};

export default PhoneVerificationModal;